/**
 * Functions that helps the string manipulation
 * like conversion, validation, and generation
 *
 * @packageDocumentation
 */

import { PlaylistId } from 'constants/enums'
import { Nullable } from 'constants/types'

const DOUBLE_QUOTES = '&quot;'
const SINGLE_QUOTES = '&apos;'

/**
 * Replace Quote strings with entities
 * @param string
 * @return string
 */
export const convertQuotesToEntity = (string: string): string => {
    return string.replace(/"/g, DOUBLE_QUOTES).replace(/'/g, SINGLE_QUOTES)
}

/**
 * Validate email format
 * @param email
 * ex 'aa@bb.ddd'
 */
export const validateEmail = (email: string): boolean => {
    const emailRegExp = new RegExp(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    )
    return emailRegExp.test(email)
}

/**
 * Validate digits only
 * @param text
 * ex '234234'
 */
export const validateDigitsOnly = (text: string): boolean => {
    const digitsRegEx = new RegExp(/^\d+$/)
    return digitsRegEx.test(text)
}

/**
 * Check if Playlist JW
 * @param string
 * @return boolean
 */
export const isPlaylistJw = (id: string): boolean => {
    return id.length === PlaylistId.JW
}

/**
 * Determine if a string value is true or false
 * @param {Nullable<string>} value
 * @param {boolean} defaultValue
 * @returns {boolean}
 */
export const strToBool = (
    value: Nullable<string>,
    defaultValue = false
): boolean => {
    const defaultString = defaultValue ? 'true' : ''
    const stringValue = value ? value.toLowerCase() : defaultString

    return stringValue == 'true' || stringValue == '1'
}

/**
 * Generate and returns a random alpha numeric
 *
 * @param {number} len - the length of generated alphanumeric string
 * @returns {string}
 */
export const getAlphaNumericRandomStr = (len: number): string => {
    const chars =
        '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'
    let str = ''
    while (str.length < len) {
        const rnum = Math.floor(Math.random() * chars.length)
        str += chars.substring(rnum, rnum + 1)
    }
    return str
}
